export const displayName = (employee) => {
  if (employee.first_name && employee.last_name) {
    return `${employee.first_name} ${employee.last_name}`;
  } else if (employee.first_name && !employee.last_name) {
    return employee.first_name;
  } else {
    return employee.email;
  }
};
